export type PaymentDirection = "deposit" | "withdraw";
export type PaymentKind = "usdt" | "wechat" | "alipay" | "bank" | "manual";
export const paymentKindLabels: Record<PaymentKind, string> = { usdt: "USDT", wechat: "微信扫码", alipay: "支付宝", bank: "银行卡", manual: "人工处理" };
export type PaymentQr = { imageId?: string; url?: string };
export type WithdrawalCategory = "crypto" | "cny";
export type PaymentChannel = {
  id: string; version: number; direction: PaymentDirection; kind: PaymentKind; name: string;
  enabled: boolean; sortOrder: number; minAmount: number; maxAmount: number; currency: "CNY";
  instructions: string; requirements: string; requirePayerName: boolean; requireReference: boolean;
  network: string; address: string; recipientName: string; bankName: string; qr: PaymentQr;
  financeContact?: string; financeUrl?: string; minUsdtAmount?: string;
  tutorial?: string; tutorialUrl?: string; withdrawalCategory?: WithdrawalCategory;
  updatedAt: string; updatedBy: string;
  history: { version: number; changedAt: string; changedBy: string; address: string; network: string; qr: PaymentQr }[];
};
export type PaymentImage = { id: string; mime: "image/png" | "image/jpeg" | "image/webp"; data: string; createdAt: string; createdBy: string };
export type PaymentSettings = { version: number; channels: PaymentChannel[]; images: PaymentImage[] };
export type PaymentAdminSettings = Omit<PaymentSettings, "images">;
export type MemberPaymentChannel = Omit<PaymentChannel, "history" | "updatedBy">;
export type MemberPaymentSettings = { version: number; channels: MemberPaymentChannel[] };
export type PaymentRequestSnapshot = {
  channelId: string; channelVersion: number; channelName: string; kind: PaymentKind; direction: PaymentDirection;
  currency: "CNY"; minAmount: number; maxAmount: number; instructions: string; requirements: string;
  network: string; address: string; recipientName: string; bankName: string; qr: PaymentQr;
  financeContact?: string; financeUrl?: string; minUsdtAmount?: string;
  tutorial?: string; tutorialUrl?: string; withdrawalCategory?: WithdrawalCategory;
  payerName: string; payerPhone?: string; reference: string; recipient?: { name: string; account: string; bankName: string };
  createdAt: string;
};
export const paymentImageUrl = (qr: PaymentQr): string => qr.imageId ? `/api/payments/images/${encodeURIComponent(qr.imageId)}` : qr.url ?? "";
export const withdrawalCategory = (channel: Pick<PaymentChannel, "kind" | "withdrawalCategory">): WithdrawalCategory => channel.kind === "usdt" || (channel.kind === "manual" && channel.withdrawalCategory === "crypto") ? "crypto" : "cny";
